module.exports = __webpack_public_path__ + "static/PFB_2018_social-a6aa03a393c31f3752c064708081b148.jpg";